import { Column } from "react-table"

export default [
    {
        Header: 'Name',
        accessor: 'name'
    },
    {
        Header: 'Label',
        accessor: 'label'
    },
    {
        Header: 'Full Name',
        accessor: 'full_name',
        width: "100%"
    }
] as Column<Interfaces.Organization>[]